/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".forgot-password[_ngcontent-%COMP%]{line-height:1.8}.site-selector-link[_ngcontent-%COMP%]{margin-top:2rem}.site-selector-link[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{cursor:pointer;color:#878787}"];
export { styles as styles };
